import { dialCodeFor } from './countries';

const digitsOnly = (value: string) => value.replace(/\D/g, '');
const EXACT_LENGTHS: Record<string, number> = { IN: 10 };

/** Country-specific v1 validation; other countries retain a safe national range. */
export function isValidNationalPhoneNumber(country: string, national: string): boolean {
  const digits = digitsOnly(national);
  const exact = EXACT_LENGTHS[country.toUpperCase()];
  if (exact) return digits.length === exact;
  const dialCode = dialCodeFor(country) ?? '';
  return digits.length >= 4 && dialCode.length + digits.length <= 15;
}

/** Exact national-number digit count for countries with a fixed length (e.g. India); undefined elsewhere. */
export function nationalPhoneLengthLimit(country: string): number | undefined {
  return EXACT_LENGTHS[country.toUpperCase()];
}
